import styles from "./BankingRightTab_organoid.module.css";
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
// 다국어 처리는 반드시 훅을 사용해야 언어 변경 시 화면이 즉각 반영됩니다.
import { useTranslation } from 'react-i18next'; 
import Swal from 'sweetalert2';

import BasicInfo from './BasicInfo';
import BankingInfoGroup from "./BankingInfoGroup";

// [임시 주석 처리] 외부 업체 시연을 위해 화면에서 숨김 처리됨. 관련 임포트는 유지합니다.
import PatientInfo_private from "./PatientInfo_private";
// import PatientInfo_public from "./PatientInfo_public"; // 아예 사용되지 않는다면 지우는 것을 권장합니다.
// import DataInput from "./DataInput"; // 미사용 임포트
// import BankingInfo from "./BankingInfo"; // 미사용 임포트

function BankingRightTab_organoid() {
    const { t } = useTranslation(); // 올바른 다국어 사용법
    const { tmpKey, tab } = useParams();

    // State 관리
    const [authLevel, setAuthLevel] = useState(null);
    const [selectedTab, setSelectedTab] = useState('default');
    const [graphImage, setGraphImage] = useState(null);

    // 1. 오가노이드 샘플이 바뀔 때마다 그래프 초기화
    useEffect(() => {
        setGraphImage(null);
    }, [tmpKey]);

    // 2. 권한 확인 (컴포넌트 최초 렌더링 시 딱 한 번만 실행)
    useEffect(() => {
        fetch('/api/getAuthLevel', { method: 'POST' })
            .then(response => {
                if (!response.ok) throw new Error(`HTTP error, status = ${response.status}`);
                return response.json();
            })
            .then(data => {
                if (data && typeof data.authLevel === 'number') {
                    setAuthLevel(data.authLevel);
                }
            })
            .catch(error => console.error("Auth level fetch error:", error));
    }, []); // 빈 배열로 두어 탭 전환 시마다 API를 쏘는 낭비를 막았습니다.

    // 3. 탭 전환 로직 (URL의 탭 파라미터가 바뀔 때만 실행)
    useEffect(() => {
        // [오타 수정] PatientInfopPrivate -> PatientInfoPrivate
        if (tab === 'PatientInfoPrivate' || tab === 'bank') {
            setSelectedTab(tab);
        } else {
            setSelectedTab('default');
        }
    }, [tab]);

    // 샘플명의 hashmark 복구 함수 (정규식 사용)
    const restoreHashMark = (str) => {
        if (!str) return '';
        return str.replace(/hashmark/g, '#');
    };

    // PDF 다운로드 핸들러
    const handleDownloadPdf = async () => {
        if (graphImage === null) {
            Swal.fire({
                icon: 'warning',
                text: t('그래프 렌더링 중입니다. 잠시 후 다시 시도해주세요.'),
                width: 320,
                padding: '1.5em',
            });
            return;
        }

        const result = await Swal.fire({
            text: t('PDF 리포트를 다운로드 하시겠습니까?'),
            icon: 'question',
            width: 320,
            padding: '1.5em',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('확인'),
            cancelButtonText: t('취소'),
            reverseButtons: true,
            customClass: {
                container: 'my-swal-container',
                popup: 'my-swal-popup',
                title: 'my-swal-title',
                content: 'my-swal-content'
            }
        });

        if (!result.isConfirmed) return;

        Swal.fire({
            title: t('PDF 생성 중...'),
            html: t('잠시만 기다려주세요.<br>데이터 양에 따라 시간이 소요될 수 있습니다.'),
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            const response = await fetch('/api/download/report/organoid', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    sampleKey: tmpKey,
                    graphImage: graphImage
                })
            });

            if (!response.ok) throw new Error('PDF generation failed');

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `Report_${restoreHashMark(tmpKey)}.pdf`;
            document.body.appendChild(a);
            a.click();
            
            a.remove();
            window.URL.revokeObjectURL(url);
            Swal.close();

        } catch (error) {
            console.error('Download error:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: t('PDF 다운로드 중 오류가 발생했습니다.'),
                confirmButtonText: t('확인')
            });
        }
    };

    return (
        <div className={styles.rightTab}>
            <div className={styles.topMenu}>
                <div className={styles.curOrganoidWrapper}>
                    <div className={styles.curOrganoid}>
                        {t('현재 오가노이드')} : {restoreHashMark(tmpKey)}
                    </div>
                    <div
                        className={styles.pdfDownloadBtn}
                        onClick={handleDownloadPdf}
                        title={t("리포트 다운로드")}
                    >
                        📄 {t('PDF 다운로드')}
                    </div>
                </div>

                <div />

                <div />
                <div />
                
                {/* ========================================================= */}
                {/* [임시 주석] 외부 업체 시연을 위해 임시로 숨김 (Patient Info) */}
                {/* <div className={`${selectedTab === 'PatientInfoPrivate' ? styles.topTabFront : styles.topTabBack}`}
                    onClick={() => setSelectedTab('PatientInfoPrivate')}
                >
                    Patient Information
                </div> 
                */}
                {/* ========================================================= */}

                <div className={`${selectedTab === 'default' ? styles.topTabFront : styles.topTabBack}`}
                    onClick={() => setSelectedTab('default')}
                >
                    Basic Information
                </div>

                <div />
                <div className={`${selectedTab === 'bank' ? styles.topTabFront : styles.topTabBack}`}
                    onClick={() => setSelectedTab('bank')}
                >
                    Banking Information
                </div>
            </div>

            <div className={styles.rightTabBottomBox}>
                {selectedTab === 'PatientInfoPrivate' ? (
                    <div>
                        {/* 임시로 탭이 닫혀있으나 데이터는 유지됨 */}
                        <PatientInfo_private />
                    </div>
                ) : selectedTab === 'bank' ? (
                    <div>
                        <BankingInfoGroup />
                    </div>
                ) : (
                    <div>
                        <BasicInfo
                            param={tmpKey}
                            setGraphImage={setGraphImage}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}

export default BankingRightTab_organoid;